/* eslint-disable @typescript-eslint/no-inferrable-types */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import cellEditFactory from 'react-bootstrap-table2-editor';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator';
import { TableContainer, Table, TableHead, TableBody, TableRow } from '@mui/material';
import { getTableViewList, createTableView, updateTableView, deleteTableView, getGroupName, getBrandCustom } from '../../../../store/actions';

import {
    Col,
    Row,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    Form,
    Label,
    Input,
    DropdownItem,
    Modal,
    Card,
    CardBody,
    CardTitle,
    CardText,
} from 'reactstrap';

import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

import Icon from '@ailibs/feather-react-ts';

import './Itable.scss';
import Convert_HTML_To_PDF from '../../ExportPdf/ExportPdf';

import ViewModuleIcon from '@mui/icons-material/ViewModule'; //cards
import ViewListIcon from '@mui/icons-material/ViewList'; //table
import AccountTreeIcon from '@mui/icons-material/AccountTree';//Tree
import SteeperHeaderSH from '../../SteeperHeaderSH/SteeperHeaderSH';
import IitemsTree from '../iItemsTree/IitemsTree';
import DownloadTableXlsx from '../../DowloadTableXlsx/DownloadTableXlsx';

// import "../../assets/images/dosan.png";
export const ITable = ({
    /* Pagination */
    CountItems,
    remote = false,
    valuesSizePagination,
    isLoading = false,

    enableView = true,
    enableDownload = true,
    enableTemporaryView = true,

    groupName,
    data,
    fields,
    tableColumns,
    pagSize,
    pageStartIn,
    showTotal,
    disablePageTitle,
    updateFunction,
    headerColorT,
    selectRow,
    actionOnRowClick,
    handlePopUpState,
    handlerPaginationState,
    handleTableSort,
    handlerSearchState,
    ShowViewlistCommodity = true,
    showPaginationTableProps = true,
    progressCard = { colums: "3", fontSize: "", visibility: false },
    itemsTree = false
    //If it is passed it shows the progress of sh (it is only passed in sh)
}: any) => {
    const { SearchBar } = Search;
    const { ExportCSVButton } = CSVExport;

    const dispatch = useDispatch();

    const defaultSorted: any = [
        {
            dataField: 'id', // if dataField is not match to any column you defined, it will be ignored.
            order: 'desc', // desc or asc
        },
    ];
    const [selectedViewData, setSelectedRowViewData] = useState('table');
    const [modalConfirm, setModalConfirm] = useState(false);
    const [modalViewForm, setModalViewForm] = useState({
        action: '',
        isVisible: false,
        update: false,
    });
    const { brandCustom } = useSelector((state: any) => state.clients);
    const tableViewOptions = useSelector((state: any) => state.tableViews.items);
    const { action, success } = useSelector((state: any) => state.tableViews);
    const [selectedView, setSelectedView] = useState<any>({});
    const [tableViewList, settableViewList] = useState<any>([]);
    const [groupNameCommodity, setgroupNameCommodity] = useState('');
    const [modal_xlarge, setmodal_xlarge] = useState(false);

    const [sizePerPageListState, setSizePerPageListState] = useState<any>();
    const [pageSize, setPageSize] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [scrollContentWidth, setScrollContentWidth] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);

    function removeBodyCss() {
        document.body.classList.add('no_padding');
    }
    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge);
        removeBodyCss();
    }
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color');

    useEffect(() => {
        dispatch(getBrandCustom());
    }, []);

    useEffect(() => {
        const newArray = valuesSizePagination?.map((item: any) => {
            return {
                text: item.toString(),
                value: Number(item),
            };
        });
        setPageSize(newArray ? newArray[0].value : 50);
        setSizePerPageListState(
            newArray ?? [
                {
                    text: '50',
                    value: 50,
                },
                {
                    text: '100',
                    value: 100,
                },
                {
                    text: '200',
                    value: 200,
                },
                {
                    text: '300',
                    value: 300,
                },
                {
                    text: '400',
                    value: 400,
                },
                {
                    text: '500',
                    value: 500,
                },
            ],
        );
    }, []);

    useEffect(() => {
        if (groupName) {
            setgroupNameCommodity(groupName);
            dispatch(getTableViewList({ groupName }));
            if (groupName != 'commodityViewList') {
                dispatch(getGroupName(groupName));
            }
        }
    }, [dispatch, groupName]);

    useEffect(() => {
        const newArray = tableViewOptions;
        let temporaryView = localStorage.getItem(`TemporaryView-${groupName}`);

        if (enableTemporaryView && temporaryView) {
            temporaryView = JSON.parse(temporaryView);
            if (newArray && newArray != undefined && newArray != null) {
                if (newArray?.some((item: any) => item.name === 'Temporary View')) {
                    newArray.shift();
                }
                newArray.splice(0, 0, temporaryView);
            }
        }
        settableViewList(newArray);
        if (tableViewOptions != null && tableViewOptions !== undefined && selectedView.length === 0) {
            const defaultItem = tableViewOptions.filter((option: any) => option.default === true)[0] || [];
            defaultItem?.items?.sort((a: any, b: any) => a.order - b.order);

            if (defaultItem !== undefined && (defaultItem.length !== 0 || temporaryView === null)) {
                setSelectedView(defaultItem);
            } else if (tableViewOptions.length > 0) {
                setSelectedView(tableViewOptions[0]);
            } else {
                //setSeletedView({})
            }
            if (defaultItem.length === 0 && temporaryView !== null) {
                setSelectedView(temporaryView);
            }
        }
    }, [tableViewOptions]);

    useEffect(() => {
        if (
            (action === 'create' && success === 'true') ||
            (action === 'update' && success === 'true') ||
            (action === 'delete' && success === 'true')
        ) {
            dispatch(getTableViewList({ groupName: groupName }));
        }
    }, [action, success, dispatch]);

    const [arrayTable, setArrayTable] = useState(tableColumns);
    const initialViewFormState = {
        name: '',
        columns: [],
        default: false,
    };

    useEffect(() => {
        if (!modalViewForm.isVisible && !modalViewForm.update) {
            const seletedItem = tableViewOptions?.filter((option: any) => option.name === selectedView.name)[0] || [];
            seletedItem?.items?.sort((a: any, b: any) => a.order - b.order);
            setSelectedView(seletedItem ?? []);
            setArrayTable(
                seletedItem?.items?.map((item: any) => {
                    return { ...item, text: item.label };
                }) ?? [],
            );
            formatArrayTable();
        }

        if (modalViewForm.isVisible) setSelectedRowView(null);
    }, [modalViewForm]);

    const tableRef2 = useRef<HTMLDivElement>(null);
    const horizontal_scroll = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            const container = tableRef2.current;
            const scrollBar = horizontal_scroll.current;
            if (container && scrollBar) {
                const containerRect = container.getBoundingClientRect();
                scrollBar.style.left = `${containerRect.left}px`;
                scrollBar.style.width = `${containerRect.width}px`;
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [scrollContentWidth, containerWidth]);

    useEffect(() => {
        const container = tableRef2.current;
        if (container) {
            const resizeObserver = new ResizeObserver(() => {
                setContainerWidth(container.offsetWidth);
            });
            resizeObserver.observe(container);
            return () => resizeObserver.disconnect();
        }
    }, [scrollContentWidth]);

    useEffect(() => {
        const container = tableRef2.current?.querySelector('.react-bootstrap-table.table-responsive2');
        if (container) {
            setScrollContentWidth(container.scrollWidth);
        }
    }, [arrayTable, data, selectedView]);


    useEffect(() => {
        const horizontalScroll = horizontal_scroll.current
        const tableElement = tableRef2.current?.querySelector('.react-bootstrap-table.table-responsive2') as HTMLElement;
        if (horizontalScroll && tableElement) {
            horizontalScroll.addEventListener('scroll', (e) => {
                const scrollLeft = (e.target as HTMLElement).scrollLeft;
                tableElement.scrollLeft = scrollLeft;
            });
            tableElement.addEventListener('scroll', () => {
                const scrollLeft = tableElement.scrollLeft;
                horizontalScroll.scrollLeft = scrollLeft;
            });
        }
        return () => {
            if (horizontalScroll && tableElement) {
                horizontalScroll.removeEventListener('scroll', () => { });
                tableElement.removeEventListener('scroll', () => { });
            }
        };
    }, [scrollContentWidth]);

    const formatArrayTable = (thisSeletedView: any = selectedView) => {
        const visibleColumns: any[] = cleanTableColumns();
        if (thisSeletedView?.items && thisSeletedView.groupName === groupName) {
            const orderedColumns = thisSeletedView.items.flatMap((viewItem: any) =>
                visibleColumns.filter(
                    (col: any) => col.text === viewItem.label && col.visibleInTable
                )
            );
            setSelectedView(thisSeletedView)
            setArrayTable(orderedColumns);
            return;
        }

        setArrayTable(visibleColumns);
    };
    const [viewForm, setViewForm] = useState<any>(initialViewFormState);

    useEffect(() => {
        formatArrayTable();
    }, [selectedView, tableColumns]);

    // Handle Actions
    const handleViewSelectChange = (name: any) => {
        const seletedItem = tableViewOptions.filter((option: any) => option.name === name)[0] || [];
        setSelectedView(seletedItem);
    };

    const handleModalConfirm = () => {
        setModalConfirm(!modalConfirm);
    };

    const cleanTableColumns = () => {
        if (!tableColumns || tableColumns.length === 0) return [];
        const hasVisibility = Object.prototype.hasOwnProperty.call(tableColumns[0], "visibleInTable");
        const filtered = hasVisibility
            ? tableColumns.filter((col: any) => col.visibleInTable === true)
            : [...tableColumns];
        const unique = filtered.filter((col: any, index: any, self: any) =>
            index === self.findIndex((c: any) => c.dataField === col.dataField)
        );

        return unique;
    };

    const handlerTempViewForm = () => {
        if (viewForm.columns.length !== 0) {
            setModalViewForm({ ...modalViewForm, isVisible: false, update: true });
            const newArray = tableViewOptions;
            const newObject = {
                name: 'Temporary View',
                groupName,
                items: viewForm.columns.map((item: any) => {
                    return { ...item, label: item.text };
                }),
            };
            if (newArray.some((item: any) => item.name === 'Temporary View')) newArray.shift();
            newArray.splice(0, 0, newObject);
            localStorage.setItem(`TemporaryView-${groupName}`, JSON.stringify(newObject));
            setSelectedView({ ...newObject, label: 'Temporary View' });
            settableViewList(newArray);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'You must select a column',
            });
        }
    };

    const handleModalViewForm = ({ action, isVisible }: any) => {
        setViewForm(initialViewFormState);
        let tableColumnsVisible = cleanTableColumns();
        if (action === 'new') {
            tableColumnsVisible = tableColumnsVisible.map((item: any, index: number) => {
                item.isChecked = false;
                return item;
            });
            setArrayTable(tableColumnsVisible);
            setViewForm(initialViewFormState);
        }
        const itemSeleccionados = selectedView.items;
        if (action === 'edit') {
            const res = tableColumnsVisible.filter((f: any) => {
                return itemSeleccionados.every((item: any) => {
                    return item.dataField === f.dataField;
                });
            });
            tableColumnsVisible = tableColumnsVisible.map((item: any, index: number) => {
                if (
                    itemSeleccionados.some((itemseleccionado: any) => {
                        return itemseleccionado.dataField === item.dataField;
                    })
                ) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
                return item;
            });

            const uploadForm = {
                name: selectedView.name,
                columns: itemSeleccionados,
                default: selectedView.default,
            };
            setArrayTable(
                tableColumnsVisible.sort((a: any, b: any) => {
                    if (a.isChecked && !b.isChecked) {
                        return -1;
                    } else if (!a.isChecked && b.isChecked) {
                        return 1;
                    } else {
                        return a.order - b.order;
                    }
                }),
            );
            setViewForm(uploadForm);
            const data = { ...uploadForm };
            //handleViewForm(data);
        }
        setModalViewForm({
            action,
            isVisible,
            update: false,
        });
    };

    const handleViewForm = (data: any) => {
        setViewForm(data);
    };

    const handleModalViewFormOnClick = (form: any) => {
        form.groupName = groupName;
        if (form.name != '') {
            if (modalViewForm.action === 'new') {
                dispatch(createTableView(form));
            }
            if (modalViewForm.action === 'edit') {
                dispatch(updateTableView(form));
            }
            setModalViewForm({ ...modalViewForm, isVisible: false, update: true });
            setViewForm(form);
            formatArrayTable({
                ...selectedView,
                default: form.default,
                items: form.columns.map((item: any) => {
                    return { ...item, label: item.text };
                }),
            });
        }
    };
    const modalViewConfirmOnClick = () => {
        dispatch(deleteTableView({ groupName: groupName, name: selectedView.name }));
        handleModalConfirm();
        formatArrayTable({})
    };

    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }: any) => {
        return (
            <div className="btn-group" role="group">
                {options.map((option: any) => {
                    const isSelect = String(pageSize) === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'button-pagination' : 'button-pagination-outline'}`}
                        >
                            {option.text}
                        </button>
                    );
                })}
            </div>
        );
    };

    const handlerPagination = (sizePerPage: number, page: number) => {
        setCurrentPage(page);
        setPageSize(sizePerPage);
        handlerPaginationState({ sizePerPage, page });
    };

    const options = {
        totalSize: CountItems ?? 0,
        hideSizePerPage: (CountItems ?? 0) <= (sizePerPageListState ? sizePerPageListState[0].value : 50),
        custom: !showPaginationTableProps,
        sizePerPageList: sizePerPageListState,

        sizePerPageRenderer,
        onSizePerPageChange: (sizePerPage: number, page: number) => {
            handlerPagination(sizePerPage, page);
        },
        onPageChange: (page: number, sizePerPage: number) => {
            handlerPagination(pageSize, page);
        },
    };

    const reorderArray = (event: { oldIndex: any; newIndex: any }, originalArray: any[]) => {
        const movedItem = originalArray.find((item: any, index: any) => index === event.oldIndex);
        const remainingItems = originalArray.filter((item: any, index: any) => index !== event.oldIndex);
        const reorderedItems = [...remainingItems.slice(0, event.newIndex), movedItem, ...remainingItems.slice(event.newIndex)];
        return reorderedItems;
    };

    const changeOrder = (index: any, direction: string, action: number = 0) => {
        if (arrayTable.length > 0) {
            if (index == 0 && direction == 'UP') {
                return;
            }
            if (index == arrayTable.length - 1 && direction == 'DOWN') {
                return;
            }
            const item = arrayTable[index];
            if (item !== undefined) {
                let result = [];
                let newIndex = null;
                if (action === 0) {
                    newIndex = index + (direction === 'UP' ? -1 : 1);
                    result = reorderArray({ oldIndex: index, newIndex }, arrayTable);
                } else if (action === 1) {
                    newIndex = direction === 'UP' ? 0 : arrayTable.length;
                    result = reorderArray({ oldIndex: index, newIndex }, arrayTable);
                } else if (action === 2) {
                    const indexArray = tableColumns
                        .sort((a: any, b: any) => {
                            if (a.isChecked && !b.isChecked) return -1;
                            if (!a.isChecked && b.isChecked) {
                                return 1;
                            } else return a.order - b.order;
                        })
                        .findIndex((item: any) => !item.isChecked);
                    newIndex = direction === 'UP' ? indexArray - 1 : indexArray;
                    result = reorderArray({ oldIndex: index, newIndex }, arrayTable);
                }
                setSelectedRowView(newIndex);
                setArrayTable(result);
                result = result.map((item: any, index: number) => {
                    if (item.isChecked) {
                        item.order = String(index);
                        return item;
                    }
                });
                const listSelected = result.filter((column: any) => column?.isChecked === true);
                viewForm.columns = listSelected;
            }
        }
    };

    const handleClickEvent = {
        onClick: (e: any, row: any, rowIndex: any) => {
            const switchTarget = e.target.className.toLowerCase().includes('switch');
            if (actionOnRowClick && !switchTarget) {
                actionOnRowClick(row);
                handlePopUpState();
            }
        },
    };

    const handleClickEventCard = (card: any) => {
        actionOnRowClick(card);
        handlePopUpState();
    };

    const handleCheckbox = (event: any, item: any, index: any) => {
        let newColumns: any[] = [];
        viewForm.columns.length === 0 ? (item.order = 1) : (item.order = viewForm.columns.length + 1);
        item.isChecked = event.target.checked;
        if (event.target.checked) {
            changeOrder(index, 'UP', 2);
            newColumns = [...viewForm.columns];
        } else {
            changeOrder(index, 'DOWN', 2);
            newColumns = viewForm.columns.filter((column: any) => column.dataField !== item.dataField);
        }
        const data = { ...viewForm, columns: newColumns };

        handleViewForm(data);
    };

    const renderViewDropdown = () => {
        return (
            <UncontrolledDropdown>
                <select defaultValue={selectedView} className="form-select" onChange={(e) => handleViewSelectChange(e.target.value)}>
                    <option selected value="">
                        Initial View
                    </option>
                    {tableViewList &&
                        tableViewList
                            .map((option: any, index: number) => (
                                <option value={option.value} selected={option.name === selectedView.name}>
                                    {option.name}
                                </option>
                            ))
                            .sort()}
                </select>
            </UncontrolledDropdown>
        );
    };

    const renderViewActions = () => (
        <div className="col-sl-1">
            <UncontrolledDropdown>
                <DropdownToggle type="button" className="btn btn-secondary">
                    <i className="mdi mdi-cog fa-lg"> </i>
                </DropdownToggle>
                <div className="position-absolute">
                    <DropdownMenu className="mt-1" style={{ marginLeft: -3 }}>
                        <DropdownItem to="#">
                            <div onClick={() => handleModalViewForm({ action: 'new', isVisible: true })}>New</div>
                        </DropdownItem>
                        {selectedView?.name && selectedView?.name !== 'Temporary View' ? (
                            <>
                                <DropdownItem divider />
                                <DropdownItem to="#">
                                    <div onClick={() => handleModalViewForm({ action: 'edit', isVisible: true })}>Edit</div>
                                </DropdownItem>
                                <DropdownItem to="#">
                                    <div onClick={handleModalConfirm}>Delete</div>
                                </DropdownItem>
                            </>
                        ) : null}
                    </DropdownMenu>
                </div>
            </UncontrolledDropdown>
        </div>
    );

    const renderModalConfirm = () => (
        <Modal
            isOpen={modalConfirm}
            toggle={() => {
                handleModalConfirm();
            }}
            backdrop={'static'}
            id="staticBackdrop"
        >
            <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                    Delete View
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        handleModalConfirm();
                    }}
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <p>
                    Are you sure you want to delete the <b>{selectedView?.name}</b> ?
                </p>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => {
                        handleModalConfirm();
                    }}
                >
                    Close
                </button>
                <button type="button" className="btn btn-danger" onClick={modalViewConfirmOnClick}>
                    Delete
                </button>
            </div>
        </Modal>
    );

    const [selectRowView, setSelectedRowView] = useState<number | null>(null);

    const renderModalViewForm = () => (
        <Modal
            isOpen={modalViewForm.isVisible}
            zIndex={99999999999}
            toggle={() => {
                handleModalViewForm({ action: '', isVisible: false });
            }}
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    Select Fields
                </h5>
                <button
                    type="button"
                    onClick={() => {
                        handleModalViewForm({ action: '', isVisible: false });
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <Form>
                    <div className="mb-2">
                        <Label className="form-label" htmlFor="viewName">
                            View Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="viewName"
                            defaultValue={viewForm.name}
                            readonly={modalViewForm.action === 'edit'}
                            onChange={(e) => handleViewForm({ ...viewForm, name: e.target.value })}
                        />
                    </div>
                    <div className="mb-2">
                        {selectRowView !== null ? (
                            <div className="position-fixed containerFloat">
                                <Icon
                                    className="btnFloat col-12 mb-2"
                                    name="arrow-up-circle"
                                    size={50}
                                    color="currentColor"
                                    onClick={() => changeOrder(selectRowView, 'UP')}
                                />
                                <Icon
                                    className="btnFloat col-12"
                                    name="arrow-down-circle"
                                    size={50}
                                    color="currentColor"
                                    onClick={() => changeOrder(selectRowView, 'DOWN')}
                                />
                            </div>
                        ) : null}
                        {arrayTable?.map((column: any, index: number) => {
                            return (
                                <div
                                    className="form-check custom-checkbox row"
                                    style={{
                                        backgroundColor: index === selectRowView ? '#F3F5F5' : 'transparent',
                                    }}
                                >
                                    <Input
                                        type="checkbox"
                                        className="form-check-input col-2 mt-2"
                                        id={column.dataField}
                                        checked={column.isChecked}
                                        defaultChecked={viewForm.columns.find((item: any) => item.label === column.text)}
                                        onChange={(e) => handleCheckbox(e, column, index)}
                                    />
                                    <Label
                                        className="form-check-label col-4 "
                                        onClick={() => setSelectedRowView(index !== selectRowView ? index : null)}
                                        style={{ minWidth: '150px' }}
                                    >
                                        {column.text}
                                    </Label>
                                    {/* <button className="btnUpDown col-1" onClick={(e) => { e.preventDefault(); changeOrder(index, "UP") }}
                  >
                    <InnoboIcon name="fa-solid fa-chevron-up" />
                  </button>
                  <button className="btnUpDown col-1" onClick={(e) => { e.preventDefault(); changeOrder(index, "DOWN") }}
                  >
                    <InnoboIcon name="fa-solid fa-angle-down" />
                  </button> */}

                                    <button
                                        className="btnUpDown col-1"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeOrder(index, 'UP', 1);
                                        }}
                                    >
                                        <Icon name="chevrons-up" color="currentColor" />
                                    </button>
                                    <button
                                        className="btnUpDown col-1"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeOrder(index, 'DOWN', 1);
                                        }}
                                    >
                                        <Icon name="chevrons-down" color="currentColor" />
                                    </button>
                                </div>
                            );
                        })}
                    </div>

                    <div className="form-check form-switch mb-2" dir="ltr">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizesm"
                            defaultChecked={viewForm.default}
                            onChange={(e) => handleViewForm({ ...viewForm, default: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="customSwitchsizesm">
                            Default view
                        </label>
                    </div>
                </Form>
            </div>
            <div className="modal-footer">
                <button type="button" onClick={() => handlerTempViewForm()} className="btn btn-info" data-dismiss="modal">
                    <Icon size={20} name="clock" color="currentColor" />
                </button>
                <button
                    type="button"
                    onClick={() => {
                        handleModalViewForm({ action: '', isVisible: false });
                    }}
                    className="btn btn-secondary "
                    data-dismiss="modal"
                >
                    Close
                </button>
                <button type="button" className="btn btn-primary" onClick={() => handleModalViewFormOnClick(viewForm)}>
                    {modalViewForm.action === 'edit' ? 'Update' : 'Create'}
                </button>
            </div>
        </Modal>
    );
    const tableRef = useRef(null);

    const handleSearch = () => {
        setCurrentPage(1);
        setPageSize(sizePerPageListState[0].value);
        handlerPaginationState({
            sizePerPage: sizePerPageListState[0].value,
            page: '1',
        });
        //handlerSearchState(searchQuery)
    };

    const LoadingIndicator = () => {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(isLoading);
    }, [data, isLoading]);

    const tableToPdf = () => {
        const logoClient = brandCustom?.logo;
        return (
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow className="head">
                            <img className="logo_pdf" src={logoClient} alt="" height={57} />
                        </TableRow>
                        <TableRow className="headers">
                            {arrayTable
                                ? arrayTable.map((value: any) => {
                                    if (value.dataField != 'id') {
                                        return (
                                            <th className="th_head" style={{ border: '1px solid gainsboro' }}>
                                                {value.text}
                                            </th>
                                        );
                                    }
                                })
                                : null}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data
                            ? data?.map((obj: any) => {
                                return (
                                    <tr>
                                        {arrayTable.map((header: any) => {
                                            if (header.dataField != 'id') {
                                                const head = header.dataField;
                                                if (head === 'enabled' || head === 'MCA_ACTIVO' || head === 'MCA_SUPERUSUARIO') {
                                                    return (
                                                        <td className="td_body" style={{ border: '1px solid gainsboro' }}>
                                                            {obj[head] ? obj[head].toString() : null}
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td className="td_body" style={{ border: '1px solid gainsboro' }}>
                                                        {obj[head]}
                                                    </td>
                                                );
                                            }
                                        })}
                                    </tr>
                                );
                            })
                            : null}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    const changeDataView = (view: string) => {
        if (selectedViewData == view) {
            return;
        } else {
            setSelectedRowViewData(view);
        }
    };

    //CARD Functionality

    const renderCard = (obj: any, index: Number) => (
        <Card
            onClick={() => {
                handleClickEventCard(obj);
            }}
            key={`cards-${obj.id}-${index}`}
            inverse
            style={{}}
        >
            {renderHeaderCard(obj)}
            {progressCard.visibility && renderProgresSh(obj)}
            {renderBodyCard(obj)}
        </Card>
    );

    const renderProgresSh = (obj: any) => {
        return (
            <div className='Container_progress_ShCards border-bottom text-black'>
                <SteeperHeaderSH textXs={progressCard.fontSize} data={obj} />
            </div>
        );
    };




    const renderHeaderCard = (obj: any) => (
        <div className="card-header border-bottom">
            {arrayTable.map((header: any) => {
                const head = header.dataField;
                const title = header.text;
                if (title == 'Number') {
                    return (
                        <div>
                            <i className="dripicons-bookmarks"></i>
                            {title} - {obj[head] ? obj[head].toString() : '-'}
                        </div>
                    );
                }
            })}
        </div>
    );

    const renderBodyCard = (obj: any) => (
        <CardBody className="information-card">
            {arrayTable.map((header: any) => {
                const head = header.dataField;
                const title = header.text;
                if (title == 'Number') {
                    return (
                        <div className="information-box-on-card" key={`dataCards-${head}`}>
                            <CardTitle tag="h6">
                                <i className="dripicons-bookmarks"></i> {title}
                            </CardTitle>
                            <CardText className="text-black">{obj[head] ? obj[head].toString() : '-'}</CardText>
                        </div>
                    );
                } else if (title?.includes('Date')) {
                    return (
                        <div className="information-box-on-card" key={`dataCards-${head}`}>
                            <CardTitle tag="h6">
                                <i className=" dripicons-calendar"></i> {title}
                            </CardTitle>
                            <CardText className="text-black">{obj[head] ? obj[head].toString() : '-'}</CardText>
                        </div>
                    );
                } else if (title?.includes('Seller') || title?.includes('Buyer')) {
                    return (
                        <div className="information-box-on-card" key={`dataCards-${head}`}>
                            <CardTitle tag="h6">
                                <i className="dripicons-briefcase"></i> {title}
                            </CardTitle>
                            <CardText className="text-black">{obj[head] ? obj[head].toString() : '-'}</CardText>
                        </div>
                    );
                } else if (title?.includes('Pieces')) {
                    return (
                        <div className="information-box-on-card" key={`dataCards-${head}`}>
                            <CardTitle tag="h6">
                                <i className="dripicons-basket"></i> {title}
                            </CardTitle>
                            <CardText className="text-black">{obj[head] ? obj[head].toString() : '-'}</CardText>
                        </div>
                    );
                }
                else if (title?.includes('Status') || title?.includes('CFstatus')) {
                    return (
                        <div className="information-box-on-card" key={`dataCards-${head}`}>
                            <CardTitle tag="h6">
                                <i className="mdi mdi-list-status"></i> {title}
                            </CardTitle>
                            <CardText className="text-black">{obj[head] ? obj[head].toString() : '-'}</CardText>
                        </div>
                    );
                }

                return (
                    <div className="information-box-on-card" key={`dataCards-${head}`}>
                        <CardTitle tag="h6">{title}</CardTitle>
                        <CardText className="text-black">{obj[head] ? obj[head].toString() : '-'}</CardText>
                    </div>
                );
            })}
        </CardBody>
    );

    const renderTable = () => {
        if (options.sizePerPageList) {
            const columns =
                arrayTable.length === 0
                    ? [{ id: null }]
                    : arrayTable.map((item: any) => {
                        if (item?.dataField?.substring(0, 2) === 'CF') return item;
                        return {
                            ...item,
                            sort: item.sort === undefined || item.sort ? true : false,
                            sortCaret: (order: any) => {
                                if (!order) return <span></span>;
                                else if (order === 'asc') return <i className="bx bx-up-arrow-alt iboxIconArrow"></i>;
                                else if (order === 'desc') return <i className="bx bx-down-arrow-alt iboxIconArrow"></i>;
                                return null;
                            },
                        };
                    });
            const tableData = isLoading ? [] : arrayTable.length === 0 ? [] : data ?? [];

            const noDataIndicator = loading
                ? LoadingIndicator
                : arrayTable.length === 0
                    ? 'There are no columns configured for this view.'
                    : 'No Data';
            return (
                <div className="table">
                    <Row>
                        <PaginationProvider pagination={paginationFactory(options)}>
                            {({ paginationProps, paginationTableProps }) => (
                                <ToolkitProvider
                                    keyField="id"
                                    data={tableData} //-------------- puede tener la data actual
                                    columns={columns}
                                    bootstrap4
                                    search
                                    exportCSV
                                >
                                    {(toolkitProps: any) => (
                                        <React.Fragment>
                                            {enableDownload ? (
                                                <div className="search" style={{ maxWidth: '1300px' }}>
                                                    <Col xs={12} sm={12} md={12} ml={12} lg={12} xl={12}  >
                                                        <div className="d-flex flex-wrap gap-2 justify-content-end">
                                                            {(ShowViewlistCommodity && groupName !== '') && enableView ? (
                                                                <>
                                                                    {renderViewDropdown()}
                                                                    {renderViewActions()}
                                                                </>
                                                            ) : null}

                                                            {selectedViewData == 'table' && (
                                                                <>
                                                                    <ExportCSVButton class="btn btn-secondary button-icon" {...toolkitProps.csvProps}>
                                                                        <i className="fas fa-file-csv fa-lg"></i>
                                                                    </ExportCSVButton>
                                                                    <link
                                                                        rel="stylesheet"
                                                                        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
                                                                    ></link>
                                                                    <button
                                                                        className="btn btn-secondary button-icon"
                                                                        onClick={() => {
                                                                            tog_xlarge();
                                                                        }}
                                                                        data-toggle="modal"
                                                                        data-target=".bs-example-modal-center"
                                                                    >
                                                                        <i className="fas fa-file-pdf fa-lg"></i>
                                                                    </button>

                                                                    <DownloadTableXlsx filename="data" sheetName="data" tableRef={tableRef}>
                                                                        <button className="btn btn-secondary button-icon">
                                                                            <i className="fas fa-file-excel fa-lg"></i>
                                                                        </button>
                                                                    </DownloadTableXlsx>
                                                                </>
                                                            )}

                                                            <button
                                                                onClick={() => {
                                                                    changeDataView('table');
                                                                }}
                                                                className={`btn btn-secondary button-icon ${selectedViewData == 'table' && 'button-icon-selected'
                                                                    }`}
                                                            >
                                                                <ViewListIcon />
                                                            </button>

                                                            <button
                                                                onClick={() => {
                                                                    changeDataView('card');
                                                                }}
                                                                className={`btn btn-secondary button-icon ${selectedViewData == 'card' && 'button-icon-selected'
                                                                    }`}
                                                            >
                                                                <ViewModuleIcon />
                                                            </button>

                                                            {itemsTree && (
                                                                <button
                                                                    onClick={() => {
                                                                        changeDataView('Tree');
                                                                    }}
                                                                    className={`btn btn-secondary button-icon ${selectedViewData == 'Tree' && 'button-icon-selected'
                                                                        }`}
                                                                >
                                                                    <AccountTreeIcon />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </div>
                                            ) : null}

                                            <div style={{ padding: '0% 0% 0% 0%', display: `${selectedViewData != 'table' ? 'none' : 'block'}` }}>
                                                <div ref={tableRef2} className="table-responsive">
                                                    <BootstrapTable
                                                        {...toolkitProps.baseProps}
                                                        {...paginationTableProps}
                                                        onTableChange={handleTableSort ?? (() => null)}
                                                        remote={remote ?? false}
                                                        selectRow={selectRow}
                                                        rowEvents={handleClickEvent}
                                                        defaultSorted={defaultSorted}
                                                        headerClasses={headerColorT}
                                                        classes={'table align-middle table-nowrap table-hover'}
                                                        filter={filterFactory()}
                                                        bordered={true}
                                                        striped={false}
                                                        loading={loading}
                                                        noDataIndication={noDataIndicator}
                                                        wrapperClasses="table-responsive2"

                                                    />
                                                    {remote ? <PaginationTotalStandalone {...paginationProps} /> : null}
                                                    <div ref={horizontal_scroll} id="horizontal-scroll" className="horizontal-scroll">
                                                        <div style={{ width: `${scrollContentWidth}px` }} className="scroll-content"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ padding: '0% 0% 0% 0%', display: `${selectedViewData != 'card' ? 'none' : 'block'}` }}>
                                                <Card>
                                                    <div style={{ gridTemplateColumns: `repeat(${progressCard.colums}, 1fr)` }} className="container-cards">
                                                        {data && data.map((obj: any, index: number) => renderCard(obj, index))}
                                                    </div>
                                                </Card>

                                                <div>
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>

                                                {remote ? <PaginationTotalStandalone {...paginationProps} /> : null}
                                            </div>

                                            {itemsTree && (
                                                <div style={{ padding: '0% 0% 0% 0%', display: `${selectedViewData != 'Tree' ? 'none' : 'block'}` }}>
                                                    <IitemsTree actionOnRowClickTreeView={handleClickEventCard} CommodityList={data} milestoneConfig={arrayTable} />

                                                    {/* <div>
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>

                                                {remote ? <PaginationTotalStandalone {...paginationProps} /> : null} */}
                                                </div>
                                            )}

                                            <Modal
                                                size="xl"
                                                zIndex="20000000"
                                                isOpen={modal_xlarge}
                                                toggle={() => {
                                                    tog_xlarge();
                                                }}
                                            >
                                                <button
                                                    onClick={() => {
                                                        setmodal_xlarge(false);
                                                    }}
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                    style={{ marginRight: '2%' }}
                                                >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <div
                                                    id="containerModal"
                                                    style={{
                                                        height: '650px',
                                                        overflowY: 'scroll',
                                                        padding: '2%',
                                                    }}
                                                >
                                                    <div id="contentToPrint">{tableToPdf()}</div>
                                                </div>
                                                <div className="container-button">
                                                    <button className="btn btn-secondary btn btn-secondary" onClick={Convert_HTML_To_PDF}>
                                                        <i className="bi bi-filetype-pdf" style={{ fontSize: '2em' }}></i>
                                                    </button>
                                                </div>
                                            </Modal>

                                            <div className="table-responsive tableP">
                                                <table ref={tableRef} className="table-to-excel">
                                                    <thead>
                                                        <tr style={{ height: '90px', padding: '2%' }}>
                                                            <td>
                                                                <img style={{ margin: '15px' }} src={brandCustom?.logo} alt="" height={57} />
                                                            </td>
                                                        </tr>
                                                        <tr style={{ height: '90px', padding: '2%' }}>
                                                            {arrayTable
                                                                ? arrayTable.map((value: any, index: number) => (
                                                                    <th
                                                                        key={`ThEx${index}`}
                                                                        style={{
                                                                            backgroundColor: primaryColor,
                                                                            color: 'white',
                                                                            border: '1px solid gainsboro',
                                                                            padding: '8px',
                                                                        }}
                                                                    >
                                                                        {value.text}
                                                                    </th>
                                                                ))
                                                                : null}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data
                                                            ? data.map((obj: any, rowIndex: number) => (
                                                                <tr key={`RowEx${rowIndex}`}>
                                                                    {arrayTable.map((header: any, colIndex: number) => {
                                                                        const head = header.dataField;
                                                                        return (
                                                                            <td
                                                                                key={`ColEx${colIndex}`}
                                                                                className="td_body"
                                                                                style={{
                                                                                    border: '1px solid gainsboro',
                                                                                }}
                                                                            >
                                                                                {obj[head] != null && obj[head] != undefined ? obj[head].toString() : ''}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))
                                                            : null}
                                                    </tbody>
                                                    {/* FOOTER */}
                                                    <tfoot>
                                                        <tr>
                                                            {arrayTable.map((header: any, index: number) => {
                                                                let footerValue = '';
                                                                if (header.footer) {
                                                                    footerValue = header.footer;
                                                                }
                                                                return (
                                                                    <td
                                                                        key={index}
                                                                        style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'white',
                                                                            border: '1px solid gainsboro',
                                                                            backgroundColor: primaryColor,
                                                                        }}
                                                                    >
                                                                        {footerValue}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>

                                            </div>
                                        </React.Fragment>
                                    )}
                                </ToolkitProvider>
                            )}
                        </PaginationProvider>
                    </Row>
                </div>
            );
        }
    };

    return (
        <div className="container-sm">
            {renderTable()}
            {renderModalViewForm()}
            {renderModalConfirm()}
        </div>
    );
};

ITable.propTypes = {
    CountItems: PropTypes.number,
    handlerPaginationState: PropTypes.func,
    handleTableSort: PropTypes.func,
    remote: PropTypes.bool,
    valuesSizePagination: PropTypes.array,
    isLoading: PropTypes.bool,

    enableView: PropTypes.bool,
    enableDownload: PropTypes.bool,
    enableTemporaryView: PropTypes.bool,

    ShowViewlistCommodity: PropTypes.bool,

    data: PropTypes.array,
    fields: PropTypes.array,
    tableColumns: PropTypes.array,
    headerColorT: PropTypes.string,
    pagSize: PropTypes.number,
    pageStartIn: PropTypes.number,
    showTotal: PropTypes.bool,
    disablePageTitle: PropTypes.bool,
    updateFunction: PropTypes.func,
    selectRow: PropTypes.object,
    actionOnRowClick: PropTypes.func,
    tableViewList: PropTypes.array,
    groupName: PropTypes.string,
    handlePopUpState: PropTypes.func,

    showPaginationTableProps: PropTypes.bool,
    progressCard: PropTypes.any,
    itemsTree: PropTypes.bool
};
